import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
export const OpeningHook = () => {
  return <AnimatedSection className="border-t border-ink/10 bg-paper" data-id="element-121">
      <div className="mb-12 text-center" data-id="element-122">
        <span className="uppercase tracking-widest text-xs font-semibold text-ink/50" data-id="element-123">
          CAPÍTULO 01 · EL CONTEXTO
        </span>
      </div>

      <div className="max-w-3xl mx-auto space-y-8 text-lg md:text-xl font-sans leading-relaxed text-ink/90" data-id="element-124">
        <p className="drop-cap" data-id="element-125">
          Si hoy abrís la app de tu banco y sentís que tus pesos se evaporan
          antes de llegar a fin de mes, no estás solo. Mientras la inflación
          corre más rápido que tu sueldo, existe un grupo de argentinos que dejó
          de preocuparse por el Blue porque empezaron a cobrar en la moneda que
          lo controla todo.
        </p>

        <p data-id="element-126">
          Lo hacen aprovechando un "vacío" en el mercado: empresas de Miami,
          España y México están desesperadas por personas que sepan gestionar
          sus chats. No buscan expertos en marketing, buscan personas que sepan
          hablar con otros humanos.
        </p>
      </div>
    </AnimatedSection>;
};